import Stopwatch from "Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/Stopwatch";
import { MODALS } from "Containers/Pages/Modal";
import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setPublicPuzzleAndPuzzleType,
  declareVictory,
} from "Store/features/public/publicPuzzleSlice";
import {
  setPublicModal,
} from "Store/features/public/publicStateSlice";

// import CrossWordTopBar from "./CrosswordTopBar";
import Keyboard from "./Keyboard";

import "./PublicCrossword.css";
import PublicGameButtonGroup from "Components/PublicGameButtonGroup";
import { recordUserGameStat } from "API/Puzzles";

const PublicCrossword = ({
  crosswordGrid: grid,
  clues,
  selectedCell,
  selectedDirection,
}) => {
  const dispatch = useDispatch();
  const className = `game-container`;
  const publicPuzzleState = useSelector((state) => state.publicPuzzleSlice);
  const puzzle = useSelector((state) => state.publicPuzzleSlice.puzzle);
  const [emptyRows, setEmptyRows] = useState(0);
  const authToken = useSelector(
    (state) => state.publicUserSlice.postcastAuthToken
  );

  const { time } = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.timer
  );

  const { puzzleId } = useSelector((state) => state.publicPuzzleSlice);

  const winner = useSelector((state) => state.publicPuzzleSlice.puzzle.winner);
  const idFromCoordinate = (coordinate) => {
    return "[" + String(coordinate) + "]";
  };
  const clueNumberGridLocations = useMemo(() => {
    let localEmptyRows = 0;
    const resultMap = {};
    grid.forEach((row, rowIndex) => {
      let rowEmpty = true;
      row.forEach((cell, colIndex) => {
        if (cell.clueNumber) {
          // console.log(String([rowIndex, colIndex]));
          resultMap[cell.clueNumber] = idFromCoordinate([rowIndex, colIndex]);
        }
        if (cell.answer) rowEmpty = false;
      });
      if (rowEmpty) localEmptyRows += 1;
    });
    setEmptyRows(localEmptyRows);
    return resultMap;
  }, [grid]);

  const squareToSelectedSquares = useMemo(() => {
    // {
    //   [x,y]: {
    //     across: [[x1, y1], ... , [xn, yn]],
    //     down: [[x1, y1], ... , [xn, yn]]
    //   }
    // }
    const cellToWordCoordinates = {};

    const { across, down } = clues;
    across?.forEach((clue) => {
      console.log({ clue });
      console.log(clueNumberGridLocations[clue.number]);
      const [rowIndex, colIndex] = JSON.parse(
        clueNumberGridLocations[clue.number]
      );
      const wordCoordinates = [[rowIndex, colIndex]];
      let localCol = colIndex + 1;
      // Iterate across to the right;
      while (grid[rowIndex][localCol] && grid[rowIndex][localCol].answer) {
        wordCoordinates.push([rowIndex, localCol]);
        localCol += 1;
      }
      wordCoordinates.forEach((cord) => {
        if (!cellToWordCoordinates[idFromCoordinate(cord)]) {
          cellToWordCoordinates[idFromCoordinate(cord)] = {
            across: wordCoordinates,
          };
        } else {
          cellToWordCoordinates[idFromCoordinate(cord)].across =
            wordCoordinates;
        }
      });
    });
    down?.forEach((clue) => {
      // console.log(clueNumberGridLocations[clue.number]);
      const [rowIndex, colIndex] = JSON.parse(
        clueNumberGridLocations[clue.number]
      );
      const wordCoordinates = [[rowIndex, colIndex]];
      let localRow = rowIndex + 1;
      while (
        grid[localRow] &&
        grid[localRow][colIndex] &&
        grid[localRow][colIndex].answer
      ) {
        wordCoordinates.push([localRow, colIndex]);
        localRow += 1;
      }
      wordCoordinates.forEach((cord) => {
        if (!cellToWordCoordinates[idFromCoordinate(cord)]) {
          cellToWordCoordinates[idFromCoordinate(cord)] = {
            down: wordCoordinates,
          };
        } else {
          cellToWordCoordinates[idFromCoordinate(cord)].down = wordCoordinates;
        }
      });
    });
    return cellToWordCoordinates;
  }, [clueNumberGridLocations, clues, grid]);

  const cellBelow = useCallback(
    (rowI, cellI) => {
      return (
        grid &&
        grid[rowI + 1] &&
        grid[rowI + 1][cellI] &&
        grid[rowI + 1][cellI].answer
      );
    },
    [grid]
  );

  const cellAbove = useCallback(
    (rowI, cellI) => {
      return grid && grid[rowI - 1] && grid[rowI - 1][cellI];
    },
    [grid]
  );

  const cellToRight = useCallback(
    (rowI, cellI) => {
      return (
        grid &&
        grid[rowI] &&
        grid[rowI][cellI + 1] &&
        grid[rowI][cellI + 1].answer
      );
    },
    [grid]
  );

  const cellToLeft = useCallback(
    (rowI, cellI) => {
      return (
        grid &&
        grid[rowI] &&
        grid[rowI][cellI - 1] &&
        grid[rowI][cellI - 1].answer
      );
    },
    [grid]
  );

  const handleChangeCellValue = useCallback(
    (changeCellRow, changeCellCol, val) => {
      if (!selectedCell) return;
      let newSelectedCell = null;
      const newGrid = grid.map((row, rowIndex) => {
        return row.map((col, colIndex) => {
          if (val === "DEL") {
            if (rowIndex === changeCellRow && colIndex === changeCellCol) {
              return {
                ...grid[rowIndex][colIndex],
                value: "",
                selectedLetter: false,
              };
            }
            if (
              selectedDirection === "down" &&
              rowIndex === changeCellRow - 1 &&
              colIndex === changeCellCol
            ) {
              newSelectedCell = [rowIndex, colIndex];
              return {
                ...grid[rowIndex][colIndex],
                selectedLetter: true,
              };
            }
            if (
              selectedDirection === "across" &&
              rowIndex === changeCellRow &&
              colIndex === changeCellCol - 1
            ) {
              newSelectedCell = [rowIndex, colIndex];
              return {
                ...grid[rowIndex][colIndex],
                selectedLetter: true,
              };
            }
            return {
              ...grid[rowIndex][colIndex],
              selectedLetter: false,
            };
          } else {
            if (rowIndex === changeCellRow && colIndex === changeCellCol) {
              return {
                ...grid[rowIndex][colIndex],
                value: val.toUpperCase(),
                selectedLetter: false,
              };
            }

            if (
              selectedDirection === "down" &&
              rowIndex === changeCellRow + 1 &&
              colIndex === changeCellCol
            ) {
              newSelectedCell = [rowIndex, colIndex];
              return {
                ...grid[rowIndex][colIndex],
                selectedLetter: true,
              };
            }
            if (
              selectedDirection === "across" &&
              rowIndex === changeCellRow &&
              colIndex === changeCellCol + 1
            ) {
              newSelectedCell = [rowIndex, colIndex];
              return {
                ...grid[rowIndex][colIndex],
                selectedLetter: true,
              };
            }
            return {
              ...grid[rowIndex][colIndex],
              selectedLetter: false,
            };
          }
        });
      });
      dispatch(
        setPublicPuzzleAndPuzzleType({
          ...publicPuzzleState,
          puzzle: {
            ...puzzle,
            grid: newGrid,
            selectedCell: newSelectedCell,
          },
        })
      );
    },
    [
      publicPuzzleState,
      puzzle,
      selectedDirection,
      selectedCell,
      grid,
      setPublicPuzzleAndPuzzleType,
      dispatch,
    ]
  );

  const handleChangeSelectedCellsValue = useCallback(
    (
      direction,
      selectedCoordinates,
      selectedLetterRowIndex,
      selectedLetterColIndex
    ) => {
      const cordsById = selectedCoordinates.map((cord) =>
        idFromCoordinate(cord)
      );
      const newGrid = grid.map((row, rowIndex) => {
        return row.map((col, colIndex) => {
          const selectedLetter =
            rowIndex === selectedLetterRowIndex &&
            colIndex === selectedLetterColIndex;
          if (
            cordsById.indexOf(idFromCoordinate([rowIndex, colIndex])) !== -1
          ) {
            return {
              ...grid[rowIndex][colIndex],
              selectedWord: true,
              selectedLetter,
            };
          }
          return {
            ...grid[rowIndex][colIndex],
            selectedWord: false,
            selectedLetter,
          };
        });
      });
      dispatch(
        setPublicPuzzleAndPuzzleType({
          ...publicPuzzleState,
          puzzle: {
            ...puzzle,
            grid: newGrid,
            selectedCell: [selectedLetterRowIndex, selectedLetterColIndex],
            selectedDirection: direction,
          },
        })
      );
    },
    [grid, publicPuzzleState, dispatch]
  );

  const victory = useMemo(() => {
    return grid?.every((row) =>
      row.every((c) => {
        return !c.answer || c?.answer?.toUpperCase() === c.value?.toUpperCase();
      })
    );
  }, [grid]);

  const recordGame = useCallback(async () => {
    console.log("Recording game");
    if (!winner) {
      console.log("No winner");
      if (authToken) {
        console.log("Auth token");
        recordUserGameStat(authToken, puzzleId, time, dispatch);
      }
      dispatch(declareVictory());
      dispatch(setPublicModal(MODALS.WINNER));
    }
  }, [authToken, puzzleId, dispatch, winner, time]);
  if (victory && !winner) {
    recordGame();
  }

  const handleClickCell = useCallback(
    (rowIndex, colIndex) => {
      if (!grid[rowIndex][colIndex]?.answer) return;
      const { across, down } =
        squareToSelectedSquares[idFromCoordinate([rowIndex, colIndex])];
      if (
        across &&
        across.length &&
        (!selectedCell ||
          !selectedDirection ||
          selectedDirection === "down" ||
          (selectedDirection === "across" && selectedCell[0] !== rowIndex) ||
          selectedCell[1] !== colIndex)
      )
        handleChangeSelectedCellsValue("across", across, rowIndex, colIndex);
      else if (down && down.length)
        handleChangeSelectedCellsValue("down", down, rowIndex, colIndex);
    },
    [grid, puzzle, squareToSelectedSquares]
  );

  const handleKeyPress = useCallback(
    (key) => {
      handleChangeCellValue(selectedCell[0], selectedCell[1], key);
    },
    [selectedCell]
  );

  const handleClickTrophyIcon = useCallback(() => {
    dispatch(setPublicModal(MODALS.WINNER));
  }, [dispatch]);

  const handleClickShareIcon = async () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Postcast!",
          text: "Play this game!",
          url: window.location.href,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText("play this game!");
        console.log("Content copied to clipboard");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    }
  };
  return (
    <div className={className}>
      <div className="crossword-clue-section-container">
        <div className="crossword-clues-container-header">
          <b>Clues | Time Elaped</b>
          <Stopwatch small={true} />
          <PublicGameButtonGroup />
        </div>

        <div className="crossword-clues-container">
          <div className="crossword-clue-container">
            <b>Across</b>
          </div>
          {clues?.across?.map((c) => (
            <div className="crossword-clue-container">
              <b></b>
              {c.number}: {c.clue}
            </div>
          ))}
          <div className="crossword-clue-container">
            <b>Down</b>
          </div>
          {clues?.down?.map((c) => (
            <div className="crossword-clue-container">
              <b></b>
              {c.number}: {c.clue}
            </div>
          ))}
        </div>
      </div>
      {victory ? (
        <> YOU won! NICE ONE!</>
      ) : (
        <div className="crossword-grid">
          {grid?.map((row, rowIndex) => {
            const emptyRow = row?.every((c) => !c.answer);
            return (
              <div
                key={rowIndex}
                className={`crossword-row ${emptyRow ? "empty" : ""}`}
              >
                {row?.map((cell, colIndex) => {
                  const isCellBelow = cellBelow(rowIndex, colIndex);
                  const isCellAbove = cellAbove(rowIndex, colIndex);

                  const isCellToRight = cellToRight(rowIndex, colIndex);
                  const isCellToLeft = cellToLeft(rowIndex, colIndex);

                  const numEmptyRows = `empty-rows-${emptyRows}`;

                  return (
                    <div
                      className={`${cell.answer ? "cell" : "cell empty"} ${
                        cell.selectedWord ? "selected-word" : ""
                      } ${cell.selectedLetter ? "selected-letter" : ""} ${
                        isCellBelow ? "cellBelow" : ""
                      } ${isCellAbove ? "cellAbove" : ""} ${
                        isCellToRight ? "cellToRight" : ""
                      } ${isCellToLeft ? "cellToLeft" : ""} ${numEmptyRows}`}
                      key={colIndex}
                      disabled={!cell.answer}
                      onClick={() => {
                        handleClickCell(rowIndex, colIndex);
                      }}
                    >
                      {cell.answer && (
                        <div className="cell-content">
                          <span className="clue-number">{cell.clueNumber}</span>
                          {cell.value}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
      <Keyboard onKeyPress={handleKeyPress} />
    </div>
  );
};

export default PublicCrossword;
